import moment from "moment-business-days";
import tz from "moment-timezone";
tz.tz.setDefault("America/Sao_Paulo");
export default moment;



// WEBPACK FOOTER //
// ./src/utils/moment.js